import {
	KForm,
	KTextField
} from "kinnect-general";

export default KForm.extend( {
	name: "FacilityMaintenanceVendorTypeForm",

	props: {
		vendorType: Object,

		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "facilityMaintenanceVendorTypes" } ]
		}
	},

	data: () => ( {
		formFields: {
			name: null
		}
	} ),

	computed: {
		editing() {
			return Boolean( this.vendorType );
		},

		formUrl() {
			return this.editing
				? `facility-maintenance/vendor-types/${this.vendorType.id}`
				: "facility-maintenance/vendor-types";
		}
	},

	watch: {
		vendorType: {
			handler( vendorType ) {
				if ( vendorType ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( vendorType.hasOwnProperty( key ) ) {
							this.formFields[key] = vendorType[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				label="Name*"
				prependIcon="person"
				required
				vModel={this.formFields.name}
				validationName="name"
				validationRules="required"
			></KTextField>
		</KForm>;
	}
} );
